import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from '../../context/DashboardContext';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, Legend, Category, Tooltip, BarSeries, DataLabel, Highlight } from '@syncfusion/ej2-react-charts';
import { InputLabel, MenuItem, FormControl, Select, Skeleton } from '@mui/material'
import { FaStar, FaRegStar } from "react-icons/fa";
import chroma from 'chroma-js';

export default function PessoaXDemandas({ corFavorito, cicloDemandaKey, swotKey, tab }) {
    const theme = localStorage.getItem('theme') || 'light'
    const { qtdPessoaXDemanda, setQtdPessoaXDemanda, getPessoaXDemanda, PessoaXDemanda, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)

    const axisLabelRender = (args) => {
        theme == 'light' ? args.labelStyle.color = '#fff' : args.labelStyle.color = '#3f3f46'
        if (args.axis.name === 'primaryXAxis' && args.text.length > 30) {
            args.text = args.text.substring(0, 30) + "...";
        }
    };

    useEffect(() => {
        if (cicloDemandaKey != "") {
            setIsLoading(true)
            getPessoaXDemanda(cicloDemandaKey, qtdPessoaXDemanda)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [cicloDemandaKey, qtdPessoaXDemanda])

    const primaryxAxis = {
        title: '',
        titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
        labelIntersectAction: 'wrap',
        labelStyle: {
            textAlignment: 'center'
        },
        valueType: 'Category',
        interval: 1,
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 }
    };
    const primaryyAxis = { title: 'Pessoa', titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' }, majorTickLines: { width: 0 }, majorGridLines: { width: 0 }, lineStyle: { width: 0 } }

    const onPointRender = (args) => {
        const baseColor = '#EB425A';

        const colorPalette = chroma.scale([chroma(baseColor).darken(1), baseColor, chroma(baseColor).brighten(1)])
            .mode('lab')
            .colors(args.series.dataSource.length);

        args.fill = colorPalette[args.point.index];
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("Pessoa x Demandas")} className='btn-grafico'>{corFavorito("Pessoa x Demandas") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>Demandas x Pessoas</span>
                </h2>
                <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="qtd-demanda-3">Quantidade de demandas</InputLabel>
                    <Select
                        className='span-bsc'
                        labelId="qtd-demanda-label-3"
                        id="qtd-demanda-3"
                        value={qtdPessoaXDemanda}
                        label="Quantidade de demandas"
                        onChange={(e) => setQtdPessoaXDemanda(parseInt(e.target.value))}
                    >
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="40">40</MenuItem>
                        <MenuItem value="1000">Todas</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div style={{ width: '100%', minHeight: '450px' }}>
                {isLoading ?
                    <Skeleton variant="rounded" width="100%" height={450} />
                    :
                    <ChartComponent id={`${tab}-pessoaxdemanda`} style={{ textAlign: "center" }} legendSettings={{ enableHighlight: true }}
                        primaryXAxis={primaryxAxis} primaryYAxis={primaryyAxis} axisLabelRender={axisLabelRender} chartArea={{ border: { width: 0 } }} tooltip={{ enable: true, header: "<b>${point.tooltip}</b>" }} width="1200" height={'100%'} title='' pointRender={onPointRender}>
                        <Inject services={[BarSeries, Legend, Tooltip, Category, DataLabel, Highlight]} />
                        <SeriesCollectionDirective >
                            <SeriesDirective
                                cornerRadius={{ bottomRight: 5, topRight: 5 }}
                                dataSource={PessoaXDemanda.sort((a, b) => a.y - b.y)}
                                tooltipMappingName='toolTipMappingName'
                                xName='x'
                                columnSpacing={0.01}
                                yName='y'
                                type='Bar'
                                marker={{
                                    dataLabel: {
                                        font: {
                                            size: '16px',
                                            fontWeight: '500'
                                        },
                                        visible: true,
                                        position: "Top",
                                        template: (point) => {
                                            return `${point.point.y}`;
                                        },
                                    },
                                }}
                            />
                        </SeriesCollectionDirective>
                    </ChartComponent>
                }
            </div>
        </>
    )
}